import React from 'react'
import { Trans } from 'react-i18next'
import Font from 'src/components/Core/Typography/Font/Font'
import Accordion from 'src/components/Organisms/Accordion/Accordion'
import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'

import utils from '../../../../../components/Organisms/Form/utils'
import t from '../../../../../translations/main'
import { ConfigCompanyDetails } from '../CompanyDetails/types'

const accordion = (
  <Accordion
    key='creditLinesNote'
    title={t('onboarding.forms.CorporateAccount.IndividuallyAgreedTermsScheduleForm.visualOnly.creditLinesNote.title')}
    isOpen>
    {/* @ts-ignore */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.IndividuallyAgreedTermsScheduleForm.visualOnly.creditLinesNote.content'} />
  </Accordion>
)

const ClientMoneyRulesText = (
  <Font
    key='clientMoneyRules'
    tag='h4'
    bold
  >
    {t('onboarding.forms.CorporateAccount.IndividuallyAgreedTermsScheduleForm.visualOnly.clientMoneyRules')}
  </Font>
)

const ContactDetailsForPortfolioText = (
  <Font
    key='contactDetailsForPortfolio'
    bold
    ellipsis={false}
  >
    {t('onboarding.forms.CorporateAccount.IndividuallyAgreedTermsScheduleForm.visualOnly.contactDetailsForPortfolio')}
  </Font>
)

const config = ({ currencies }: ConfigCompanyDetails) => utils.injectTranslation({
  id: 'IndividuallyAgreedTermsScheduleForm',
  path: 'onboarding.forms.CorporateAccount.IndividuallyAgreedTermsScheduleForm.inputs',
  content: [
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'grid',
          path: 'onboarding.forms.CorporateAccount.IndividuallyAgreedTermsScheduleForm.inputs',
          props: {
            marginBottom: 'auto',
          },
          content: [
            {
              componentType: 'grid',
              props: {
                alignContent: 'flex-start',
                rowGap: '24px'
              },
              content: [
                {
                  componentType: '',
                  visualComponent: ClientMoneyRulesText
                },
                {
                  componentType: 'radioGroup',
                  props: {
                    name: 'clientMoneyRules',
                    minHeight: '0',
                    dataList: [
                      {
                        id: 'clientMoneyRules1',
                        label: t('components.forms.labels.apply'),
                        value: 'apply',
                      },
                      {
                        id: 'clientMoneyRules2',
                        label: t('components.forms.labels.disapply'),
                        value: 'disapply',
                      },
                    ],
                    removeLabelEllipsis: true,
                    required: true,
                  },
                },
                {
                  componentType: 'accordion',
                  visualComponent: accordion
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'baseCurrency',
                    removeLabelEllipsis: true,
                    minHeight: '0',
                    required: true
                  },
                  // @ts-ignore
                  custom: props => DropdownWrapper({
                    options: currencies?.filter(currency => ['USD', 'GBP', 'EUR'].includes(typeof currency.label === 'string' ? currency.label : '')),
                    name: 'baseCurrency',
                    label: 'onboarding.forms.CorporateAccount.IndividuallyAgreedTermsScheduleForm.inputs.baseCurrency.label',
                    placeholder: 'onboarding.forms.CorporateAccount.IndividuallyAgreedTermsScheduleForm.inputs.baseCurrency.placeholder',
                    wrapperWidth: '50%',
                    marginInputWrapper: '0 0 8px 0',
                    filter: true,
                    required: true,
                    ...props
                  })
                },
                {
                  componentType: 'radioGroup',
                  transformType: 'stringAndBooleanConversion',
                  props: {
                    name: 'doEmployAgent',
                    minHeight: '0',
                    dataList: [
                      {
                        id: 'doEmployAgent1',
                        label: t('components.forms.labels.yes'),
                        value: 'yes',
                      },
                      {
                        id: 'doEmployAgent2',
                        label: t('components.forms.labels.no'),
                        value: 'no',
                      },
                    ],
                    removeLabelEllipsis: true,
                    required: true,
                  },
                },
                {
                  componentType: 'input',
                  props: {
                    name: 'nameOfAgent',
                    minHeight: '0',
                    paddingLeft: '4%',
                    removeLabelEllipsis: true,
                    required: true,
                    maxlength: 150,
                  },
                },
                {
                  componentType: '',
                  visualComponent: ContactDetailsForPortfolioText
                },
                {
                  componentType: 'input',
                  submitValidation: 'email',
                  props: {
                    name: 'discrepancyEmail',
                    minHeight: '0',
                    removeLabelEllipsis: true,
                    required: true,
                    maxlength: 150,
                  },
                },
                {
                  componentType: 'input',
                  submitValidation: 'email',
                  props: {
                    name: 'disputeNotice',
                    minHeight: '0',
                    required: true,
                    maxlength: 150,
                  },
                },]
            }
          ],
        }
      ]

    },
  ],
})

export default config
